module.exports = __webpack_public_path__ + "static/media/cloudy.f951fe50.svg";